/**
 *
 * @type {{submit: string, about: string, last_name_label: string, create_an_account: string, required: string, course_sequence_name: string, undo: string, log_in: string, country_label: string, role_label: string, newest: string, explore_courses: string, retry: string, sign_in: string, sign_out: string, role_name_label: string, courses: string, upload_new: string, password_label: string, first_name_label: string, photo: string, continue_: string, my_profile: string, email_label: string, most_popular: string, existing_user: string}}
 */
const common = {
  app_title: 'Formation en ligne sur la gestion de niveau intermédiaire',
  explore_courses: 'Explorer les cours',
  create_an_account: 'Créer un compte',
  existing_user: 'Déjà inscrit ?',
  log_in: 'Se connecter',
  sign_in: 'Connexion',
  sign_out: 'Déconnexion',
  my_profile: 'Mon profil',
  courses: 'Cours',
  about: 'À propos de',
  submit: 'Envoyer',
  email_label: "E-mail",
  country_label: "Pays",
  required: 'Tous les champs sont obligatoires',
  password_label: 'Mot de passe',
  undo: "annuler",
  retry: "Réessayer",
  course_sequence_name: 'Cours {sequence}: {name}',
  newest: 'Les plus récentes',
  most_popular: 'Les plus populaires',
  first_name_label: 'Prénom',
  last_name_label: 'Nom de famille',
  role_label: 'Rôle',
  role_name_label: 'Nom du rôle',
  photo: 'Photo',
  upload_new: 'Charger de nouvelles',
  continue_: 'Continuer',
  required_field_message: 'Ce champ est requis',
  dismiss: 'Congédier',
  expired_session_message: 'Votre session a expiré. Veuillez vous reconnecter',
  saved: 'Enregistrée',
  yes: 'Oui',
};

/**
 *
 * @type {{h1: string}}
 */
const nav = {
  h1: 'Formation MLM en ligne'
};

/**
 *
 * @type {{subscribe_label: string, subscribe: string, who_office: string, links: string, telephone: string, fax: string, updates: string, subscribe_placeholder: string}}
 */
const footer = {
  links: 'Liens',
  who_office: 'Organisation mondiale de la santé - Bureau régional pour l\'Afrique Cité du Djoué, P.O.Box 06 Brazzaville République du Congo',
  telephone: 'Téléphone',
  fax: 'Fax',
  updates: 'Mises à jour',
  subscribe_label: 'Veuillez vous inscrire pour recevoir des mises à jour sur des sujets liés aux cours de MLM.',
  subscribe: 'S\'abonner',
  subscribe_placeholder: 'Adresse e-mail',
  subscribe_success_message: 'Votre demande d\'ajout à la liste de diffusion a été envoyée',
};

/**
 *
 * @type {{p: string, enroll_course: {small: string, p: string, h3: string}, h1: string, enroll_master: {small: string, p: string, h3: string}, h3: string, welcome: string}}
 */
const home_page = {
  welcome: 'Bienvenue à',
  h1: 'La Formation en Ligne en Gestion de Niveau Intermédiaire Pour les Cadres du PEV',
  line_1: `
  Progressez dans votre carrière en acquérant les compétences techniques et managériales essentielles nécessaires pour 
  mener un programme de vaccination quel que soit le niveau. La formation MLM est désormais disponible sous forme d'une 
  série de 15 cours interactifs en ligne que tout le monde peut suivre gratuitement, à son propre 
  rythme, quand et où il le souhaite.
  `,
  line_2: `
  Dans chaque cours, les apprenants peuvent acquérir une expérience pratique en se basant sur des 
  scénarios et des exemples réalistes. Après chaque cours, ils obtiennent une certification de WHO AFRO, 
  ce qui leur permet d'être plus performants au travail et de progresser dans leur carrière.
  `,
  enroll_master: {
    small: 'SUIVRE LES 15 COURS',
    h3: 'S\'inscrire au programme Master',
    p: `
    Si vous souhaitez suivre les 15 cours en ligne et maîtriser toutes les compétences nécessaires pour 
    diriger et gérer un programme de vaccination, inscrivez-vous au programme MLM Master. 
    Prenez tout le temps nécessaire pour suivre ce programme, à raison d'un cours à la fois.
    `,
  },
  enroll_course: {
    small: 'SUIVRE DES COURS INDIVIDUELS',
    h3: 'S\'inscrire à un cours à la fois',
    p: `
    Inscrivez-vous à un ou plusieurs cours en ligne. Vous pouvez en suivre autant ou aussi peu que vous le souhaitez, 
    pour apprendre ou améliorer vos compétences. Inscrivez-vous à des cours supplémentaires à 
    tout moment et prenez le temps qu'il vous faut. 
    Si vous finissez par suivre les 15 cours, vous obtiendrez une certification master.
    `,
  },
  h3: 'Améliorez vos performances sur le terrain avec les cours de formation en ligne MLM'
};

/**
 *
 * @type {{frequently_asked_questions: string, faqs: {"0": {head: string, body: string}, "1": {head: string, body: string}, "2": {head: string, body: string}, "3": {head: string, body: string}, "4": {head: string, body: string}, "5": {head: string, body: string}}, h1: string}}
 */
const help_page = {
  h1: 'Aide',
  frequently_asked_questions: 'Foire aux questions',
  faqs: {
    0: {
      slug: 'technology',
      head: 'De quelle technologie avez-vous besoin pour suivre les cours ?',
      body: `
      <p class="text-sm lg:text-base lg:w-9/12 py-3">
      Vous devez disposer d'une connexion internet pour suivre un cours. En outre, les cours sont conçus pour être suivis sur un ordinateur de bureau ou portable utilisant une version récente de Chrome, Safari ou Firefox.  
      <strong
        >Veuillez noter que la vitesse internet peut influencer votre capacité à évoluer dans les modules.</strong
      >.
        </p>
      `,
      subcategories: [
      ]
    },
    1: {
      slug: 'advancing',
      type: 'plain',
      head: 'Avez-vous des difficultés à saisir une réponse ou à passer à l\'activité suivante ?',
      body: ``,
      subcategories: [
          {
              slug: 'internet',
              head: 'Internet',
              body: `Il s'agit d'un problème lié à la connexion Internet. Veuillez noter que la vitesse internet peut influencer votre capacité à évoluer dans les modules.  Si vous avez des difficultés à accéder à l'écran suivant, 
              <strong>vérifiez votre connexion internet, videz votre cache et actualisez votre page en conséquence.</strong>`
          }
      ]
    },
    2: {
      slug: 'understanding',
      type: 'columns',
      head: 'Vous avez des difficultés à comprendre le contenu ?',
      body: ``,
      subcategories: [
          {slug: 'hint',
           head: 'Utilisez la fonction « Conseil » ',
           image: 'help-hint.jpg',
           body: `
           Nous vous invitons à utiliser les fonctions <strong>conseil</strong> , lorsqu'elles sont disponibles.  Si vous n'avez plus de 
                <strong>conseils</strong> disponibles, vous pouvez redémarrer l'activité et vos conseils seront réinitialisés. Nous vous recommandons de noter les réponses que vous avez déjà fournies avant de recommencer une activité. Seule l'activité en cours sera réinitialisée ; vos progrès antérieurs resteront intacts.
           `},
           {slug: 'discussionboard',
           head: 'Forum de discussion',
           image: 'help-discussionboard.jpg',
           body: `
           Si vous n'avez pas pu obtenir de réponse à partir des « conseils » fournis, nous vous invitons à lire les commentaires publiés dans le forum de discussion du cours que vous suivez. Vos collègues ont peut-être rencontré le même problème et proposé des solutions. Si vous ne voyez aucune suggestion de la part de vos collègues, posez une question dans le forum de discussion.
           `},
           {slug: 'resources',
           head: 'Utiliser les ressources du cours',
           image: 'help-resources.jpg',
           body: `
           Chaque cours contient une section « Ressources » Vous y trouverez plusieurs matériels supplémentaires approuvés par l'OMS, que vous pouvez télécharger. Si vous avez des difficultés à comprendre un cours, ou si vous avez des questions qui ne relèvent pas du cours, veuillez consulter les ressources fournies. 
           `},
           {slug: 'content',
           head: 'Avez-vous relevé une erreur dans le contenu ?',
           body: `
           Les cours MLM sont conçus à partir de documents d'orientation approuvés par l'OMS, qui sont examinés et mis à jour régulièrement. En outre, tout le contenu des cours a été soigneusement étudié par des experts de l'OMS. Si vous pensez avoir identifié une erreur, commencez par poster un commentaire sur le forum de discussion et demandez à vos collègues de vous faire part de leurs observations.
           `},
      ]
    },
    3: {
      slug: 'howworks',
      type: 'stacked',
      head: 'Comment fonctionne le MLM en ligne ?',
      body: ``,
      subcategories: [
          {
              slug: 'enroll',
              head: 'Comment s\'inscrire à un cours ?',
              image: 'help-enroll.jpg',
              body: `<p class="mb-4">
              Pour vous inscrire à un cours, cliquez sur le bouton orange « S'inscrire ». Vous pouvez vous inscrire à un ou plusieurs cours qui vous intéressent, ou vous pouvez décider de participer aux 15 cours MLM pour obtenir une certification Master. C'est à vous de choisir. 
            </p>
            <p>
            Une fois que vous aurez cliqué sur le bouton « S'inscrire », vous devrez fournir quelques informations sur vous-même, votre rôle et votre lieu de résidence. Vous pourrez alors commencer à suivre le cours.
            </p>`,

          },
          {
            slug: 'earn',
            head: 'Comment obtenir une certification de cours ?',
            image: '',
            body: `<p class="mb-4">
            Vous recevrez une certification officielle du Bureau régional de l'OMS pour l'Afrique dès que vous aurez suivi un cours et réussi l'évaluation. 
            <strong
              >Il vous faudra obtenir un score d'au moins 80 % pour réussir. </strong
            >
            Vous recevrez une certification de l'OMS AFRO pour chaque cours que vous aurez suivi. Par exemple, si vous suivez trois cours, vous recevrez trois certifications distinctes.
          </p>`,

        },
        {
            slug: 'access',
            head: 'Comment accéder à votre certification ?',
            image: 'help-completed.jpg',
            body: `<p class="mb-4">
            Une fois que vous avez réussi une évaluation, vous verrez le cours sur votre tableau de bord sous la rubrique « Cours terminés ». À côté du cours achevé, vous verrez un bouton sur lequel vous pourrez cliquer pour télécharger votre certification.
          </p>`,

        },
        {
            slug: 'master',
            head: 'Comment obtenir une certification Master ?',
            image: 'help-downloadmaster.jpg',
            body: `<p class="mb-4">
            Si vous avez suivi les 15 cours de MLM, votre certification Master apparaîtra en haut de la page « Cours ».  Si vous ne pouvez toujours pas accéder à votre certification, il est probable que vous ayez obtenu une note 
            <strong>inférieure à 80 % lors de l'évaluation</strong>. 
            Veuillez revoir vos notes sur les 15 cours pour confirmer que vous avez reçu une note de passage. Une fois que vous aurez terminé les 15 cours MLM, 
            <strong>un lien pour télécharger votre certification sera disponible sous l'image du trophée vert dans votre page « Cours ».</strong>  
        </p>
        <p class="mb-4">Ce lien vous mènera à votre certification Master :  <a href="/fr/courses">https://app.who-afro-mlm.com/fr/courses</a> </p>
        `,

        },
      ]
    },
    4: {
        slug: 'profile',
        type: 'double-stacked',
      head: 'Avez-vous besoin de mettre à jour votre nom, votre mot de passe, votre photo ou votre rôle ?',
      body: ``,
      subcategories: [
          {
              slug: 'name',
              head: 'Pour modifier le nom qui figure sur votre certification',
              body: `<ul class="mb-4 list-disc ml-5">
              <li class="mb-2">Connectez-vous à votre compte MLM</li> 
              <li class="mb-2">Cliquez sur votre nom (affiché dans le coin supérieur droit de la page).</li> 
              <li class="mb-2">Sélectionnez « Modifier le profil ».</li>
              <li class="mb-2">Dans le champ intitulé « Nom », entrez votre nom tel que vous souhaitez qu'il apparaisse sur votre certificat MLM. </li> 
              <li class="mb-2">Pour éviter de changer votre mot de passe, ne tapez rien dans la section « Réinitialiser le mot de passe ».</li> 
              <li class="mb-2">Nous vous encourageons également à ajouter une photo de profil sur votre compte !</li> 
              <li class="mb-2">Enregistrez vos modifications en cliquant sur le bouton « Enregistrer les modifications ».</li>
              <li class="mb-2">Veuillez noter que le nom de votre compte apparaîtra sur votre certificat. Vous pouvez accéder à votre compte et modifier votre nom, mais 
              <strong>sachez que cette opération ne peut être effectuée qu'une seule fois sur une période de trois mois.</strong></li>
              </ul>`,
              image: 'help-profile.jpg',
              hiddenimage2: 'help-profile-editprofile.jpg'
          },          
        {
            slug: 'password',
            head: 'Pour réinitialiser votre mot de passe ',
            body: `<ul class="mb-4 list-disc ml-5">
            <li class="mb-2">Veuillez visiter le site web MLM et cliquer sur « Connexion ». </li>
            <li class="mb-2">Cliquez ensuite sur le texte bleu indiquant « Mot de passe oublié » ?  </li>
            <li class="mb-2">Une fois que vous aurez entré votre adresse électronique et cliqué sur le bouton orange de réinitialisation, vous recevrez un courriel vous indiquant comment réinitialiser votre mot de passe.</li>
          <li class="mb-2">Une fois cette opération terminée, vous pourrez vous connecter à votre compte.</li>
        </ul>`,
            image: 'help-profile-editpassword.jpg',
            hiddenimage1: 'help-profile.jpg'
        },
        {
          slug: 'photo',
          head: 'Pour modifier votre photo ou votre rôle',
          body: `<ul class="mb-4 list-disc ml-5">
          <li class="mb-2">Connectez-vous à votre compte MLM</li> 
          <li class="mb-2">Cliquez sur votre nom dans le coin supérieur droit de la page.</li> 
          <li class="mb-2">Sélectionnez « Modifier le profil ».</li> 
          <li class="mb-2">Pour ajouter ou modifier votre photo, sélectionnez « Télécharger » une nouvelle photo. 
          </li> 
          <li class="mb-2">Pour ajouter ou modifier votre rôle, sélectionnez le menu déroulant intitulé « Rôle ».</li>
        </ul>`,
          image: 'help-profile-editprofile.jpg',
          hiddenimage1: 'help-profile.jpg'
      },
      ]
    },
  }
};

/**
 *
 * @type {{"0": {p: string, button: string, h1: string}, "1": {p: string, button: string, h1: string}}}
 */
const about_page = {
  section_1: {
    h1: 'À propos des cours MLM',
    p: `
    Améliorez vos performances sur le lieu de travail en suivant un ou plusieurs des 15 cours individuels répertoriés ci-dessous. 
    Dans chaque cours, vous allez bénéficier d'une pratique appropriée, d'un retour d'information personnalisé, 
    d'un ensemble de ressources et de fiches de travail de WHO ainsi que d'un accès à une communauté d'apprenants tout comme vous. 
    Cliquez sur un cours pour découvrir les sujets abordés. Puis, commencez la formation.
    `,
    button: 'Aller aux cours'
  },
  section_2: {
    h1: 'Certification de niveau supérieur avec le programme MLM Master',
    line_1: `
    Faites progresser votre carrière en vous inscrivant au programme MLM Master. 
    Une fois inscrit(e), vous pourrez suivre automatiquement les 15 cours ci-dessous. 
    Prenez tout le temps nécessaire pour terminer la formation.
    `,
    line_2: `
    Tout au long du programme, vous allez bénéficier d'une pratique appropriée, d'un retour d'information personnalisé, 
    d'un ensemble de ressources et de fiches de travail de WHO ainsi que d'un accès à une communauté d'apprenants tout comme vous. 
    À la fin de la formation, vous obtiendrez la certification Master de WHO AFRO, une qualification qui témoigne de votre maîtrise et de votre engagement.
    `,
    button: 'Explorer les cours'
  },
};

/**
 *
 * @type {{est_time: string, you_are_enrolled: string, completed_courses: string, all_mlm_courses: string, view_details: string, enroll_master: string, enrolled_courses: string, enroll_in_courses: string, complete_the_remaining_n_courses: string, what_do_you_want_to_learn_about: string, continue_course: string, course_sequence_name: string, you_have_completed_all_courses: string, you_can_retake_courses_anytime: string, search_error_message: string, download_master_cert: string, you_have_completed_n_courses: string, my_courses: string, mlm_master_cert: string, download_cert: string, course_sequence: string, improve_your_performance: string, see_your_courses_below: string, start_course: string, enroll_success_message: string, great_start: string, search_results: string, n_courses: string, progress: string, enroll: string}}
 */
const courses_page = {
  improve_your_performance: 'Améliorez vos performances sur le terrain avec les cours de formation en ligne MLM',
  enroll_in_courses: 'Inscrivez-vous à l\'un des cours ci-dessous, ou inscrivez-vous au programme de certification MLM Master.',
  great_start: 'La création d\'un compte est un excellent début ! C\'est votre premier pas pour obtenir la certification MLM.',
  you_are_enrolled: 'Bravo ! Vous êtes inscrit au programme de certification MLM Master et sur le bon chemin pour l’obtenir.',
  see_your_courses_below: 'Consultez votre liste de cours ci-dessous.',
  n_courses: '{n} cours',
  you_have_completed_n_courses: 'Continuez votre bon travail ! Vous avez terminé {courses} jusqu\'à présent.',
  complete_the_remaining_n_courses: 'Terminez les {courses} restants pour obtenir la certification MLM Master.',
  you_have_completed_all_courses: 'Toutes nos félicitations! Vous avez terminé tous les cours du programme de certification MLM Master.',
  you_can_retake_courses_anytime: 'N\'oubliez pas de garder vos connaissances à jour. Vous pouvez reprendre les cours à tout moment.',
  download_master_cert: 'Télécharger la certification master',
  download_cert: 'Télécharger la certification',
  search_results: 'Résultats de recherche',
  all_mlm_courses: 'Tous les cours MLM',
  what_do_you_want_to_learn_about: 'Que voulez-vous apprendre ?',
  course_sequence: 'COURS {sequence}',
  course_sequence_name: common.course_sequence_name,
  view_details: 'Afficher les détails',
  est_time: 'Environ {time}',
  estimated_time: 'Durée estimée',
  enroll: 'S\'inscrire',
  enroll_now: 'S\'inscrire maintenant',
  mlm_master_cert: 'Certification MLM Master',
  enroll_master: `
  Inscrivez-vous aux 15 cours en même temps. Prenez tout le temps nécessaire pour terminer la formation. 
  Lorsque vous aurez terminé, vous obtiendrez la certification Master de WHO AFRO.
  `,
  search_error_message: 'Votre recherche n\'a retourné aucun module. Veuillez essayer une autre recherche.',
  my_courses: 'Mes cours',
  enrolled_courses: 'Cours inscrits',
  progress: 'Progrès',
  completed_courses: 'Cours complétés',
  retake_course: 'Relancer le cours',
  continue_course: 'Continuer le cours',
  start_course: 'Démarrer le cours',
  enroll_success_message: 'Vous êtes inscrit sur {course_sequence_name}',
  module_available_soon: 'Ce module sera bientôt disponible',
  master_enroll_error_message: 'Une erreur s\'est produite, certains cours n\'étaient pas inscrits',
  master_un_enroll_error_message: 'Une erreur s\'est produite, certains cours n\'étaient pas désinscrits',
  master_enroll_success_message: 'Vous êtes inscrit aux 15 cours',
  lessons: 'Leçons',
  view_my_results: 'Afficher mes résultats',
  course: 'Course',
  date_completed: 'Date d\'achèvement',
  results: 'Résultats',
  course_results: 'Résultats des cours',
  for: 'pour',
  new_courses: 'A partir de Avril 2021, un nouveau cours intitulé à 2 ans (2YL) et au-delà sera également requis pour la certification maître MLM.',
};

/**
 *
 * @type {{return_to_my_courses: string, hide_menu: string, ask_your_question_below: string, ask_an_expert: string, ask_question_here: string, restart: string, start: string, submit_question: string, resources: string, show_menu: string, no_more_activities: string, ask_expert_success_message: string}}
 */
const course_page = {
  ask_expert_success_message: 'Votre message a été envoyé',
  no_more_activities: 'Il n\'y a plus d\'activités dans ce cours',
  hide_menu: 'Masquer le menu',
  show_menu: 'Afficher le menu',
  restart: 'Recommencer',
  next_up: 'Leçon suivante',
  start: 'Commencer',
  return_to_my_courses: 'Revenir à Mes cours',
  resources: 'Ressources',
  ask_an_expert: 'Demander à un expert',
  ask_your_question_below: 'Posez votre question ci-dessous pour contacter un expert en la matière et il vous répondra rapidement par e-mail.',
  ask_question_here: 'Poser une question ici',
  submit_question: 'Envoyer la question',
  discussion_board: 'Forum de discussion',
  add_comment: 'Ajouter un commentaire',
  sort_by: 'Trier par:',
  view_n_more_comments: 'Afficher {n} autres commentaires',
  reply: 'Répondre',
  reply_to_author: 'Répondre à @{author}',
  share: 'Partager',
  like_this: 'J\'aime',
  liked: 'Aimé',
  need_help: 'Besoin d\'aide ?'
};

/**
 *
 * @type {{profile_information: string, edit_profile: string}}
 */
const profile_page = {
  edit_profile: 'Modifier le profil',
  profile_information: 'Informations sur le profil',
};

/**
 *
 * @type {{}}
 */
const profile_edit_page = {
  profile_settings: 'Paramètres du profil',
  profile: 'Profil',
  reset_password: 'Réinitialiser le mot de passe',
  return_to_profile: 'Retour au profil',
  first_name_label: common.first_name_label,
  last_name_label: common.last_name_label,
  country_label: common.country_label,
  role_label: common.role_label,
  role_name_label: common.role_name_label,
  email_label: 'Adresse e-mail',
  mobile_phone_label: 'Numéro de portable',
  save_changes: 'Enregistrer les modifications',
  cancel: 'Annuler',
  new_password_label: 'Nouveau mot de passe',
  confirm_password_label: 'Confirmer le mot de passe',
  reset_success_response: 'Votre lien de réinitialisation a été envoyé! Merci de consulter vos emails.',
  send_reset_link: 'Envoyer le lien de réinitialisation'
};

/**
 *
 * @type {{}}
 */
const survey_page = {
  please_message: 'Please complete this survey based on your experiences since taking the course.',
  thanks_message: 'Merci d\'avoir répondu au sondage.',
  h1: '{name}, vous avez terminé avec succès {module}',
  h2: 'Formation MLM OMS AFRO : Enquête en ligne',
  line_1: `
  Grâce à cette petite enquête, le programme de vaccination et de mise au point de vaccins (VMV) de WHO AFRO aidera à 
  mieux comprendre comment le matériel du cours MLM est utilisé au quotidien par les cadres intermédiaires des programmes de vaccination. 
  `,
  line_2: `
  En outre, cette étape a été intégrée comme condition pour recevoir la certification de la formation. 
  Nous vous demandons de bien vouloir répondre à cette enquête de 9 questions, qui ne prend pas plus de 10 minutes. 
  Une fois que vous aurez répondu à l'enquête, vous recevrez une certification de WHO AFRO pour la formation suivie.
  `,
  line_3: 'Nous vous remercions de prendre le temps de nous faire part de votre expérience.',
  capable_label_line_1: 'Dans quelle mesure ce cours MLM en ligne vous a-t-il permis de vous sentir plus capable de faire votre travail ?',
  capable_label_line_2: 'Veuillez noter de Moins capable (1) à Plus capable(10)',
  swipe_to_see_more: 'Glissez pour en voir plus',
  less_capable: 'moins capable',
  most_capable: 'le plus capable',
  ways_used_line_1: 'Repensez à vos expériences professionnelles des deux derniers mois. Dans quelle mesure avez-vous utilisé les compétences et les connaissances acquises grâce à ce module en ligne dans votre travail quotidien ?',
  ways_used_line_2: 'Donnez un exemple aussi précis que possible.',
  write_your_answer_here: 'Écrivez votre réponse ici...',
  measurable_improvement_label: 'Dans quelle {measurable_way} constaté une amélioration des performances de votre programme de vaccination, grâce à vos nouvelles compétences et connaissances ?',
  measurable_way: 'mesure avez-vous',
  anything_else_label: 'Y a-t-il autre chose que vous aimeriez partager sur l\'impact de l\'expérience d\'apprentissage ?',
  final_thanks: 'Nous vous remercions de votre participation à cette enquête et de votre engagement envers votre profession. C\'était la dernière étape de la formation MLM.'
};

/**
 *
 * @type {{thank_you: string, response_message: string, email_label: string, country_label: string, h1: string, h2: string, describe_label: string, required: string, name_label: string, title_label: string}}
 */
const contact_modal = {
  h1: 'Contact',
  h2: 'Contactez le siège de WHO AFRO à Brazzaville. On vous répondra dans les plus brefs délais.',
  required: common.required,
  name_label: "Nom",
  title_label: "Titre",
  email_label: common.email_label,
  country_label: common.country_label,
  describe_label: "Décrivez votre besoin de formation",
  thank_you: 'Je vous remercie',
  response_message: 'Un officier du siège de WHO AFRO à Brazzaville répondra à votre message dans les plus brefs délais.',
};

/**
 *
 * @type {{role_name_label: string, register_now: string, last_name_label: string, basic_info: string, upload_new: string, password_label: string, first_name_label: string, h1: string, photo: string, h2: string, optional: string, contact_info: string, enroll_mlm_label: string, password_confirmation_label: string, registered_user: string, country_label: string, email_label: string, role_label: string, email_confirmation_label: string, sign_in: string}}
 */
const register_modal = {
  h1: 'Inscrivez-vous pour commencer avec la formation MLM en ligne',
  h2: 'Votre nom apparaîtra ainsi sur tous les certificats que vous recevrez. Veuillez donc l\'indiquer clairement.',
  registered_user: 'Utilisateur enregistré?',
  sign_in: 'Connecter ici.',
  basic_info: 'Information de base',
  contact_info: 'Informations de contact',
  first_name_label: common.first_name_label,
  last_name_label: common.last_name_label,
  country_label: common.country_label,
  role_label: common.role_label,
  role_name_label: common.role_name_label,
  password_label: common.password_label,
  password_confirmation_label: 'Confirmation mot de passe',
  email_label: common.email_label,
  email_confirmation_label: 'Confirmer l\'adresse e-mail',
  photo: common.photo,
  optional: 'Optionnelle',
  upload_new: common.upload_new,
  enroll_mlm_label: 'Inscrivez-vous au programme MLM Master',
  register_now: 'S\'inscrire maintenant',
};

/**
 *
 * @type {{email_label: string, password_label: string, or_register_an_account: string, h1: string, forgot_password: string}}
 */
const login_modal = {
  h1: 'Connectez-vous à votre compte',
  email_label: common.email_label,
  password_label: common.password_label,
  forgot_password: 'Mot de passe oublié',
  or_register_an_account: 'ou créer un compte'
};

/**
 *
 * @type {{playback_step_1: string, playback_step_2: string, playback_step_3: string, back_btn_text: string, tour_btn_text: string, done_btn_text: string, start_step: string, next_btn_text: string, collaborate_step_2: string, collaborate_step_3: string, collaborate_step_4: string, collaborate_step_1_lg: string, collaborate_step_1_sm: string}}
 */
const tour = {
  start_step: 'Bienvenue à votre premier cours MLM ! Faire le tour...',
  playback_step_1: 'Votre cours apparaîtra dans cette zone.',
  playback_step_2: 'Pendant un cours, cliquez sur le bouton SUIVANT pour avancer à l\'écran suivant.',
  playback_step_3: 'Vous pouvez relancer ou revoir n\'importe quelle section du cours en cliquant sur ce bouton.',
  collaborate_step_1_sm: 'Vous pouvez afficher / masquer toutes les sections du cours en cliquant ici.',
  collaborate_step_1_lg: 'Cliquez ici pour afficher le cours en plein écran.',
  collaborate_step_2: 'Partagez vos questions, vos connaissances et vos conseils avec les autres professionnels du PEV qui suivent ce cours avec vous.',
  collaborate_step_3: 'Chaque cours comprend des ressources utiles dont vous pourriez avoir besoin. Téléchargez-les en cliquant sur ces icônes.',
  collaborate_step_4: 'Si vous ne trouvez pas les réponses dont vous avez besoin en discutant avec d\'autres sur le forum de discussion, nous vous recommandons de consulter la page d\'aide en ligne',
  tour_btn_text: 'Faire le tour',
  back_btn_text: 'Retour',
  next_btn_text: 'Suivant',
  done_btn_text: 'Terminer',
};

const workshops = {
  heading: 'La formation MLM des responsables intermédiaires a été remaniée pour être plus efficace, souple et interactive. Désormais, chaque module est disposnible sous forme d\'atelier et d\'e-module en ligne ; en anglais, français et portugais. Téléchargez le matériel d\'un atelier ci-dessous.',
  redesigned_workshops: 'Ateliers remaniés',
  number_workshops: '17 ateliers modulaires disponibles dans toutes combinaisons',
  guides: 'Guides de l\'animateur et du participant',
  instructions: 'Instructions détaillées pour les animateurs qui conduisent chaque atelier',
  specific_points: 'Exercices, activités et points lecture spécifiques',
  structured_pedagogy: 'Assistance pédagogique structurée tout au long du parcours',
  workshops: 'Ateliers',
  download_materials: 'Télécharger les matériels',
  online_curriculum: 'Un cursus en ligne',
  same_content: 'Le même contenu disponible dans les ateliers',
  self_paced: 'Formation selon votre propre rythme',
  highly_modular: 'Structure modulaire',
  go_to: 'Accéder à la formation MLM en ligne',
  courses: 'Cours',
  about: 'À propos de',
  help: 'Aide',
  address: 'Organisation mondiale de la santé - Bureau régional pour l\'Afrique Cité du Djoué, P.O. Box 06 Brazzaville République du Congo',
  telephone: 'Téléphone',
  fax: 'Fax',
}

/**
 *
 */
export default {
  ...common,
  nav,
  footer,
  home_page,
  help_page,
  about_page,
  courses_page,
  course_page,
  profile_page,
  profile_edit_page,
  survey_page,
  contact_modal,
  register_modal,
  login_modal,
  tour,
  workshops,
}